import React, { Component } from 'react'

export default class Contact extends Component {


    constructor(props) {
        super(props);
        this.state = {
            username: '',
            age: null,
            category: 'breakfast',
            description: '',
            errormessage: ''
        }
    }

    muSubmitHandler = (e) => {
        e.preventDefault();
        alert('You are subimiting ' + this.state.username + ' ' + this.state.age + ' ' + this.state.category + ' ' + this.state.description)
    }

    myChangeHandler = (e) => {
        let nam = e.target.name;
        let val = e.target.value;
        let err = '';
        if (nam === "age") {
            if (val != "" && !(Number(val))) {
                err = "Your age must be a number."
            } else {
                err = "";
            }
        }
        this.setState({ [nam]: val })
        this.setState({ errormessage: err })
    }



    render() {
        let detail = '';
        if (this.state.username) {
            detail = <h3 className="text-center pb-5">Form Detail: {this.state.username}  {this.state.age}  {this.state.category}  {this.state.description}</h3>
        }
        return (
            <div className="row justify-content-between pb-5">
                <h1 className="py-5 text-center text-uppercase">Have Some Questions ? </h1>
                {detail}
                <div className="row mb-5">
                    <div className="col-12 col-md-5 mb-5 mb-md-2">
                        <img src="./restaurant/images/contact-us.svg" style={{ maxWidth: '100%' }} alt="" />
                    </div>
                    <div className="col-12 col-md-7">
                        <form onSubmit={this.muSubmitHandler}>
                            <div className="mb-3">
                                <label className="form-label">Name</label>
                                <input type="text" name="username" className="form-control" onChange={this.myChangeHandler} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Age</label>
                                <input type="text" name="age" className="form-control" onChange={this.myChangeHandler} />
                                <p className="text-danger">{this.state.errormessage}</p>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Category</label>
                                <select name="category" id="" className="form-select" onChange={this.myChangeHandler} value={this.state.category}>
                                    <option value="breakfast">Breakfast</option>
                                    <option value="lunch">Lunch</option>
                                    <option value="evening">Evening</option>
                                    <option value="dinner">Dinner</option>
                                </select>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Message</label>
                                <textarea name="description" className="form-control" onChange={this.myChangeHandler} />
                            </div>
                            <button type="submit" className="btn btn-primary">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}
